module.exports = __webpack_public_path__ + "img/empty-box.e27a1ed9.svg";